import React, { useEffect, useState } from "react";
import { Card, CardContent, Typography, Box, Button, Chip, Grid, Divider, CircularProgress, Tooltip } from "@mui/material";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import StarIcon from "@mui/icons-material/Star";
import styles from "./styles.module.css";
import { useNavigate, useLocation } from 'react-router-dom';
import { axiosProxyInstance } from "../../../utils/request";

const PractitionerListing = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const authorId = localStorage.getItem("LPCurrentUserId");

  const [listings, setListings] = useState([]);
  const [decodedUser, setDecodedUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const base64Data = queryParams.get("data");
    if (base64Data) {
      try {
        const decodedString = atob(base64Data);
        const decodedObj = JSON.parse(decodedString);
        setDecodedUser(decodedObj);
        localStorage.setItem("LPCurrentUserId", decodedObj?.id);
      } catch (err) {
        console.error("Invalid base64 data:", err);
      }
    }
  }, [location.search]);

  useEffect(() => {
    const fetchListings = async () => {
      
      try {
        if (authorId) {
          const response = await axiosProxyInstance.get(`/listings?author=${authorId}&post_status=all`);
          setListings(response.data?.data?.items ?? []);
          setLoading(false);
        }
      } catch (err) {
        setError("Failed to fetch listings");
        setLoading(false);
      }
    };
    fetchListings();
  }, [decodedUser]);

  if (loading) {
    return (
      <Box className={styles.loaderContainer}>
        <CircularProgress className={styles.loader} />
      </Box>
    );
  }

  const getStatus = (post_status) => {
    let statusText = "";
    switch (post_status) {
      case "publish":
        statusText = "Active";
        break;
      case "pending":
        statusText = "Waiting for Approval";
        break;
      case "payment-pending":
        statusText = "Awaiting submission";
        break;
      case "draft":
        statusText = "Inactive";
        break;
      default:
        statusText = "Inactive";
        break;
    }
    return statusText;
  }

  const getStatusClassName = (post_status) => {
    switch (post_status) {
      case "publish":
        return styles.successChip;
      case "pending":
      case "payment-pending":
        return styles.warningChip;
      case "draft":
        return styles.inactiveChip;
      default:
        return styles.inactiveChip;
    }
  }

  const getDateBasedOnstatus = (listing) => {
    switch (listing?.post_status) {
      case "publish":
        return `Renews on: ${listing?.payment_info?.current_period_end?new Date(listing?.payment_info?.current_period_end * 1000).toLocaleDateString("en-GB"):"-"}`;
      case "pending":
      case "payment-pending":
        return "";
      case "draft":
        if(listing?.payment_info?.payment_method?.card?.exp_month && listing?.payment_info?.payment_method?.card?.exp_year){
          return `Expires on: ${listing?.payment_info?.payment_method?.card?.exp_month}/${listing?.payment_info?.payment_method?.card?.exp_year}`;
        }else{
          return `Expires on: -`;
        }
      default:
        if(listing?.payment_info?.payment_method?.card?.exp_month && listing?.payment_info?.payment_method?.card?.exp_year){
          return `Expires on: ${listing?.payment_info?.payment_method?.card?.exp_month}/${listing?.payment_info?.payment_method?.card?.exp_year}`;
        }else{
          return `Expires on: -`;
        }
    }
  }

  return (
    <Box className={styles.container}>
      <Box className={styles.header}>
        <Typography variant="gothamXL" className={styles.heading}>
          Your Listings
        </Typography>
        <Button 
          variant="contained" className={styles.addButton} 
          onClick={() => {
            localStorage.removeItem("currentCompleted");
            localStorage.removeItem("LPCurrentProvideruid");
            localStorage.removeItem("LPCurrentClinicTitle");
            localStorage.removeItem("LPCurrentClinicId");
            navigate('/practitioner/newboard')
          }}
        >
          Add New Listing
        </Button>
      </Box>

      {/* Responsive Grid Container */}
      <Grid container spacing={2}>
        {Object.values(listings).map((listing, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Card className={styles.card}>
              <CardContent className={styles.cardContent}>
                <Typography variant="h6" className={styles.cardTitle}>
                  {listing?.post_title}
                </Typography>
                <Box display='flex' alignItems='center'>
                  <Chip
                    label={getStatus(listing.post_status)}
                    size="small"
                    className={`
                        ${styles.chip}
                        ${getStatusClassName(listing.post_status)}
                        // ${"Active" === "Active" ? styles.successChip : ""}
                        // ${listing?.status === "Awaiting submission" || listing?.status === "Pending approval" ? styles.warningChip : ""}
                        // ${listing?.status === "Inactive" ? styles.inactiveChip : ""}
                      `}
                  />
                  <Typography variant="body2" className={styles.textSecondary}>
                    {getDateBasedOnstatus(listing)}
                  </Typography>
                  
                </Box>
                <Divider className={styles.divider} />
                <Box className={styles.iconText}>
                  <LocationOnOutlinedIcon fontSize="small" />
                  <Tooltip title={listing?.data.full_address}>
                    <Typography variant="body2" className={styles.descText}>{listing?.data.full_address}</Typography>
                  </Tooltip>
                </Box>
                {/* <Box className={styles.iconText}>
                  <StarIcon fontSize="small" className={styles.star} />
                  <Typography variant="body2">
                    {listing?.data.rating.ratingValue}
                    <span className={styles.ratingText}>
                      ({listing?.data.rating.totalVotes})
                    </span>
                  </Typography>
                </Box> */}
                <Box className={styles.buttonContainer}>
                  {/* {listing?.buttons?.length === 1 ? (
                    <Button variant="outlined" className={styles.actionButton} fullWidth>
                      {listing?.buttons[0]}
                    </Button>
                  ) : (
                    listing?.buttons.map((btn, idx) => ( */}

                  {
                    listing?.post_status === "publish" && (
                      <Button variant="outlined" className={styles.actionButton} onClick={(e) => {
                        navigate(`/practitioner/edit/${listing?.ID}`);
                      }}>
                        Edit
                      </Button>
                    )
                  }
                  {
                    listing?.post_status === "payment-pending"
                    ?(
                      <Button variant="outlined" className={styles.actionButton} onClick={(e) => {
                        localStorage.setItem("currentCompleted", listing?.data.initial_assessment === null ? 1 : 2 );
                        localStorage.setItem("LPCurrentProvideruid", authorId);
                        localStorage.setItem("LPCurrentClinicTitle", listing?.post_title);
                        localStorage.setItem("LPCurrentClinicId", listing?.ID);

                        navigate(`/practitioner/newboard`)
                      }}>
                        Complete Onboarding
                      </Button>
                    ):(
                      <Button variant="outlined" className={styles.actionButton} onClick={(e) => {
                        navigate(`/clinic/details/${listing?.ID}`)
                      }}>
                        View
                      </Button>
                    )
                  }
                  {/* ))
                  )} */}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PractitionerListing;
